import { action } from 'easy-peasy';

import { IActionSetAiAssistUsageOverviewReport } from '../types';

const setAiAssistUsageOverviewReport: IActionSetAiAssistUsageOverviewReport = action(
  (state, payload) => {
    const { list, pagination } = payload;

    state.aiAssistUsage.list =
      pagination.pageNumber === 1 ? list : [...state.aiAssistUsage.list, ...list];
    state.aiAssistUsage.pagination = pagination;
  },
);

export default setAiAssistUsageOverviewReport;
